import * as Yup from 'yup';
import { errorMessages } from 'components/ui/formik-controls';

export const ProductProgramSchema = Yup.object().shape({
  programId: Yup.number().required(errorMessages.required),
  isActive: Yup.boolean(),
});
